function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import * as React from "react";
function calculateDisabled(contextDisabled, fieldDisabled, name) {
  if (fieldDisabled === undefined) {
    return contextDisabled;
  }
  var isDisabled = typeof fieldDisabled === "function" ? fieldDisabled(name) : fieldDisabled;
  return isDisabled || contextDisabled;
}
export function useCommonDataContext(context, path, name, fieldDisabled) {
  // name and path is fixed per component instance and shouldn't be changes
  // eslint-disable-next-line react-hooks/exhaustive-deps -- FieldPath must never change
  var fieldPath = React.useMemo(function () {
    return [].concat(_toConsumableArray(path), [String(name)]);
  }, [name]);
  var _React$useState = React.useState(context.get(fieldPath)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    validatorResults = _React$useState4[0],
    setValidatorResults = _React$useState4[1];
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isDisabled = _React$useState6[0],
    setDisabled = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isCompact = _React$useState8[0],
    setCompact = _React$useState8[1];
  React.useEffect(function () {
    var updateState = function updateState() {
      setValue(context.get(fieldPath));
      setValidatorResults(context.getValidationResult(fieldPath));
      var options = context.getOptions();
      setCompact(options.compact);
      setDisabled(calculateDisabled(options.disabled, fieldDisabled, String(name)));
    };
    updateState();
    return context.subscribe(updateState, [fieldPath]);
  }, [context, fieldDisabled, fieldPath, name]);
  var onChange = React.useCallback(function (change) {
    context.updateField(fieldPath, change.value);
  }, [context, fieldPath]);
  return {
    value: value,
    onChange: onChange,
    compact: isCompact,
    validatorResults: validatorResults,
    disabled: isDisabled
  };
}